import React from "react";
import { MdLink } from "react-icons/md";

// The public tracking page, opened at this code.
export const TRACKING_PAGE = "https://hajexbolt.com/tracking";
export const trackingUrl = (code) =>
  `${TRACKING_PAGE}?tracking_id=${encodeURIComponent(code)}`;

/**
 * A self-delivery order's tracking code (from its first run): a small link
 * icon next to its run that copies the tracking page link for the customer.
 * `onCopied(text)` / `onFailed()` report it. Nothing shows without a code.
 */
const TrackingLink = ({ code, onCopied, onFailed }) => {
  if (!code) return null;
  const copy = async (event) => {
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(trackingUrl(code));
      onCopied?.(`Tracking link for ${code} copied`);
    } catch {
      onFailed?.();
    }
  };
  return (
    <button
      type="button"
      onClick={copy}
      title={`Tracking ${code}: copy the link for the customer`}
      aria-label={`Copy the tracking link for ${code}`}
      className="grid h-[18px] w-[18px] shrink-0 place-items-center rounded-full border-0 bg-transparent p-0 text-ui-text-subtle hover:bg-ui-surface-sunken hover:text-brand"
    >
      <MdLink aria-hidden="true" className="h-[14px] w-[14px]" />
    </button>
  );
};

export default TrackingLink;
